export interface Image {
  name: string;
  mimetype: string;
  originalname: string;
  path: string;
  destination: string;
  url: string;
}

export interface NormalizedObjectsNumber<T> {
  byId: { [id: number]: T };
  allIds: number[];
}

export interface NormalizedObjectsString<T> {
  byId: { [id: string]: T };
  allIds: string[];
}

export interface CardImage {
  name: string;
  mimetype: string;
  originalname: string;
  path: string;
  destination: string;
  url: string;
}

export enum FamilyFriendly {
  Ja = -1,
  Nein = -2
}

export const enum SharedActionTypes {
  RESET = '[shared]RESET'
}



// WEBPACK FOOTER //
// ./src/store/shared/types.ts